import { render, staticRenderFns } from "./txtMessage.vue?vue&type=template&id=c300c226&scoped=true&"
import script from "./txtMessage.vue?vue&type=script&lang=js&"
export * from "./txtMessage.vue?vue&type=script&lang=js&"
import style0 from "./txtMessage.vue?vue&type=style&index=0&id=c300c226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c300c226",
  null
  
)

export default component.exports